import styled from "styled-components";

export const SectionHeader = styled.h3(
  (props) => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(22)};
    font-family: ${props.theme.font.fontFamily};
    flex: 14;
    `
);

export const StyledModalHeader = styled.div(
  (props) => `
  display: flex;
  padding: 2rem;
  border-bottom: .1rem solid ${props.theme.colors.goBrandBlue.light};
`
);

export const StyledIcon = styled.div(
  (props) => `
  align-items: flex-end;
  justofy-content: flex-end;
  cursor: pointer;
`
);


export const Styling = styled.div`
  margin: 2rem 2rem 1rem 2rem;
`;

export const StylingDiv = styled.div`
  margin: 2rem 2rem 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const HeaderTxt = styled.p(
  (props) => `
  font-family: ${props.theme.font.fontFamily};
  font-size: 1.5rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: ${props.txtAlign ? props.txtAlign : ''};
  color: #141823;
`
);

export const FooterTxt = styled.p`
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #4f525a;
`;


export const StyledModal = styled.div(
  (props) => `
  display: flex;
  padding: 2rem;
  flex-direction: column;
`
);

export const StylingModal = styled.div`
  margin: 2rem 2rem 1rem 2rem;
`;